export default __webpack_public_path__ + "static/media/1_bottom.83f5a80c.jpg";